import { formatDateTime } from '../../../utils/formatUtils';

export const formatAuditTimestamp = (timestamp) => {
  if (!timestamp) return '';
  return formatDateTime(timestamp, { options: { dateStyle: 'short', timeStyle: 'medium' }, fallback: timestamp });
};

export const formatAuditUser = (action) => {
  if (!action) return 'Desconocido';
  if (action.user_names) return action.user_names;
  if (action.user_email) return action.user_email;
  if (action.user_uuid) return action.user_uuid;
  return 'Desconocido';
};

export const formatRequestPath = (path, endpoint) => {
  if (path) return path;
  return endpoint || '';
};

export const formatHttpMethod = (method) => (method ? method.toUpperCase() : '');

export const getStatusColor = (statusCode) => {
  if (!statusCode) return 'default';
  if (statusCode >= 200 && statusCode < 300) return 'success';
  if (statusCode >= 300 && statusCode < 500) return 'warning';
  return 'error';
};
